import { Box } from '@mui/material';
import Model from '../models/model';
import consts from '../consts';
import connectionService from '../services/Connection';
import util from '../util';
import { onChangePublish, onChangeSubscription } from './AuthorizedClientTable.js'

const inputStyle = { marginLeft: '5%', width: '90%' }
const excludedTypes = ['RFID Middleware', 'Tracking System', 'CAT Export Tracker', 'External Tracking System'];
const topicType = consts.TopicType;
const { onChangeTopic } = util;
const autocompleteValueFormatter = (value) => {
	let formatedValue = [];
	if (Array.isArray(value)) {
		formatedValue = value.map((entry) => entry?.id || entry);
	}
	return formatedValue;
}

const onCreateOption = (LookupTypeId) => (value) => {
	let action = 'save'
	let id = 0
	const formData = new FormData();
	formData.append('action', action);
	formData.append('id', id);
	formData.append('LookupTypeId', LookupTypeId);
	formData.append('CustomStringValue', value.option.id);
	formData.append('DisplayValue', value.option.id);
	try {
		fetch(connectionService.TopicPermissionLookup, {
			method: 'POST',
			body: formData,
			credentials: 'include'
		})
	} catch (error) {
		console.error('Error creating record:', error);
	}
}

const customizeInput = ({ Input, inputProps }) => {
	const field = inputProps.field
	if (inputProps.formik.values[field].length === 1 && inputProps.formik.values[field][0] === '')
		inputProps.formik.values[field] = []
	return (
		<Box style={inputStyle}>
			<Input {...inputProps} />
		</Box>
	)
}

const customizeSave = (toSave) => {
	// Add '+/data' to the Publish array if DataPermission has values
	if (toSave.PublishData.length && !toSave.Publish.includes('+/data')) {
		toSave.Publish.push('+/data')
	}
	// Add '+/cmd' to the Publish array if CmdPermission has values
	if (toSave.PublishCmdData.length && !toSave.Publish.includes('+/cmd')) {
		toSave.Publish.push('+/cmd')
	}
	// Add '+/tdata' to the Publish array if TDataPermission has values
	if (toSave.PublishTData.length && !toSave.Publish.includes('+/tdata')) {
		toSave.Publish.push('+/tdata')
	}
	// Add '+/data' to the Subscription array if SubDataPermission has values
	if (toSave.SubscribeData.length && !toSave.Subscription.includes('+/data')) {
		toSave.Subscription.push('+/data')
	}
	// Add '+/cmd' to the Subscription array if SubCmdPermission has values
	if (toSave.SubscribeCmdData.length && !toSave.Subscription.includes('+/cmd')) {
		toSave.Subscription.push('+/cmd')
	}
	// Add '+/tdata' to the Subscription array if SubTDataPermission has values
	if (toSave.SubscribeTData.length && !toSave.Subscription.includes('+/tdata')) {
		toSave.Subscription.push('+/tdata')
	}

	return toSave;
}

const model = new Model({
	name: 'TopicPermission',
	gridTitle: 'TopicPermission',
	defaultSort: 'EquipmentType',
	sortable: false,
	formTitleField: 'EquipmentType',
	disableAdd: true,
	disableDelete: true,
	showGridRefreshBtn: true,
	title: 'TopicPermission',
	combos: [
		{ type: 'Hospital', loaded: true },
		{ type: 'DeviceType', loaded: true },
		{ type: 'DataTopics', loaded: true },
		{ type: 'PubTopics', loaded: true },
		{ type: 'SubTopics', loaded: true },
		{ type: 'TDataTopics', loaded: true },
		{ type: 'PublishCmdData', loaded: true },
		{ type: 'SubscribeData', loaded: true },
		{ type: 'SubscribeTData', loaded: true },
		{ type: 'SubscribeCmdData', loaded: true },
		{ type: 'CommandDeviceType', loaded: true },
		{ type: 'CMDDataTopics', loaded: true }
	],
	formGroups: [
		{
			header: 'Subscribe',
			fields: ['Subscription', 'SubscribeData', 'SubscribeCmdData', 'SubscribeTData'],
			columnSize: 6,
			headerProps: {
				sx: {
					padding: (theme) => theme.spacing(0.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5)
				}
			},
			fieldProps: {
				inlineLabel: true
			},
			containerProps: {
				sx: {
					padding: '1.5rem !important'
				}
			}
		},
		{
			header: 'Publish',
			fields: ['Publish', 'PublishData', 'PublishCmdData', 'PublishTData', 'PublishDeviceType'],
			columnSize: 6,
			headerProps: {
				sx: {
					padding: (theme) => theme.spacing(0.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5)
				}
			},
			containerProps: {
				sx: {
					padding: '1.5rem !important'
				}
			},
			fieldProps: {
				inlineLabel: true
			}
		},
		{
			fields: ['Delay'],
			columnSize: 6,
			containerProps: {
				sx: {
					padding: '1.5rem !important'
				}
			},
			fieldProps: {
				inlineLabel: true
			}
		}
	],
	customizeSaveData: customizeSave,
	columns: [
		{ header: 'UniqueId', field: 'TopicPermissionId', hidden: true, width: 120 },
		{
			field: 'EquipmentType',
			header: 'DeviceType',
			width: 180,
			skipEmptyFilters: true,
			lookup: 'DeviceType',
			isNotformfield: true,
			sortable: false
		},
		{
			field: 'Publish',
			header: 'Publish',
			width: 230,
			lookup: 'PubTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			onCreateOption: onCreateOption(consts.LookupType.PubTopics),
			onChange: ({ formik, value })=>onChangePublish({ formik, value, isFromTopicPermission: true }),
			autocompleteValueFormatter,
			customizeInput,
			autocompleteValueParser: (value, options) => {
				let valueToShow = []
				const valuesToRemove = ['+/data', '+/cmd', '+/tdata'];
				if (value.length) {
					valueToShow = value.filter(item => !valuesToRemove.includes(item));
				}
				return valueToShow
			},
		},
		{
			field: 'PublishData',
			header: 'Datatopics',
			width: 230,
			lookup: 'DataTopics',
			preserveTypeOnSubmit: true,
			freeSolo: true,
			multiple: true,
			sortable: false,
			onCreateOption: onCreateOption(consts.LookupType.DataTopics),
			autocompleteValueFormatter,
			customizeInput,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.DataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Publish', topic: '+/data' }),
		},
		{
			field: 'PublishTData',
			header: 'Telemetrytopics',
			label: 'Telemetrytopics',
			width: 250,
			lookup: 'TDataTopics',
			preserveTypeOnSubmit: true,
			freeSolo: true,
			multiple: true,
			sortable: false,
			onCreateOption: onCreateOption(consts.LookupType.TDataTopics),
			autocompleteValueFormatter,
			customizeInput,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.TelemetryDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Publish', topic: '+/tdata' }),
		},
		{
			field: 'PublishCmdData',
			header: 'Commandtopics',
			label: 'Commandtopics',
			width: 250,
			lookup: 'CMDDataTopics',
			preserveTypeOnSubmit: true,
			freeSolo: true,
			multiple: true,
			sortable: false,
			onCreateOption: onCreateOption(consts.LookupType.CMDDataTopics),
			autocompleteValueFormatter,
			customizeInput,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.CommandDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Publish', topic: '+/cmd' }),
		},
		{
			field: 'Subscription',
			header: 'Subscribe',
			width: 250,
			lookup: 'SubTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			onCreateOption: onCreateOption(consts.LookupType.SubTopics),
			onChange: ({ formik, value })=>onChangeSubscription({ formik, value, isFromTopicPermission: true }),
			sortable: false,
			autocompleteValueFormatter,
			customizeInput,
			autocompleteValueParser: (value, options) => {
				let valueToShow = []
				const valuesToRemove = ['+/data', '+/cmd', '+/tdata'];
				if (value.length) {
					valueToShow = value.filter(item => !valuesToRemove.includes(item));
				}
				return valueToShow
			}
		},
		{
			field: 'SubscribeData',
			header: 'Datatopics',
			width: 250,
			lookup: 'DataTopics',
			preserveTypeOnSubmit: true,
			freeSolo: true,
			multiple: true,
			onCreateOption: onCreateOption(consts.LookupType.DataTopics),
			autocompleteValueFormatter,
			customizeInput,
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(consts.TopicType.DataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Subscription', topic: '+/data' }),

		},
		{
			field: 'SubscribeTData',
			header: 'Telemetrytopics',
			label: 'Telemetrytopics',
			width: 250,
			lookup: 'TDataTopics',
			preserveTypeOnSubmit: true,
			freeSolo: true,
			multiple: true,
			sortable: false,
			onCreateOption: onCreateOption(consts.LookupType.TDataTopics),
			autocompleteValueFormatter,
			customizeInput,
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(topicType.TelemetryDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Subscription', topic: '+/tdata' })
		},
		{
			field: 'SubscribeCmdData',
			header: 'Commandtopics',
			label: 'Commandtopics',
			width: 250,
			lookup: 'CMDDataTopics',
			preserveTypeOnSubmit: true,
			freeSolo: true,
			multiple: true,
			sortable: false,
			onCreateOption: onCreateOption(consts.LookupType.CMDDataTopics),
			autocompleteValueFormatter,
			customizeInput,
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(consts.TopicType.CommandDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Subscription', topic: '+/cmd' }),
		},
		{
			field: 'PublishDeviceType',
			header: 'CommandDeviceType',
			width: 150,
			preserveTypeOnSubmit: true,
			lookup: 'DeviceType',
			freeSolo: true,
			autocompleteValueFormatter,
			multiple: true,
			customizeInput,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.CommandDataWildcard),
			required: [
				{
					field: 'Publish',
					op: ({ values }) => values.Publish?.includes?.(consts.TopicType.CommandData)
				}
			],
		},
		{
			header: 'Equipmenttypedelay', field: 'Delay', width: 200, type: 'number', minValue: 0, maxValue: 10, customizeInput,
			inputWhen: ({ activeRecord }) =>
				!excludedTypes.includes(activeRecord?.record?.EquipmentType)
		}
	]
});

export default model.createFormBase();